export const accentPresets = {
  yellow: '#FFFF00',
  blue: '#3B82F6',
  green: '#22C55E',
  coral: '#F97316',
  violet: '#8B5CF6',
} as const;

export const tintScale = [0.04, 0.08, 0.12, 0.20, 0.30, 0.45, 0.60, 0.80, 1.0] as const;

export type AccentPreset = keyof typeof accentPresets;
export type TintStep = (typeof tintScale)[number];
